import { TimeRestrictions } from '../types/api';

export const shouldCheckNavigation = (timeRestrictions: TimeRestrictions) =>
  timeRestrictions.is_lock_navigation || timeRestrictions.is_lock_computer;
